import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import './ChatPopup.css'

const ChatPopup = ({ showUrlPopUp, handleCloseUrlPopup }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (showUrlPopUp.isActive) {
            setIsLoaded(true);
            document.body.style.overflow = "hidden"; // Prevent background scrolling
        } else {
            setTimeout(() => setIsLoaded(false), 500); // Delay to allow exit animation
            document.body.style.overflow = "auto";
        }
    }, [showUrlPopUp.isActive]);

    return (
        <AnimatePresence>
            {showUrlPopUp.isActive && (
                <motion.div
                    className="chat-url-popup"
                    initial={{ y: "100%", opacity: 0 }}  // Start from bottom
                    animate={{ y: "0%", opacity: 1 }}   // Slide up and appear
                    exit={{ y: "100%", opacity: 0 }}    // Slide down and disappear
                    transition={{ duration: 0.01, ease: "easeOut" }}
                >
                    {/* Embedded Website via Iframe */}
                    {isLoaded && (
                        <iframe
                            // src="https://qa-portal.tataplay.com/my-account/manage-pack/session?token=eyJhbGciOiJIUzUxMiJ9[…]erWZdFYjMWV_Nix1aGU8qREkx4ukIn-SYyhv5TBJqFM77m7ptVlqYtCdA"
                            src="https://www.tataplay.com/"
                            title="Chatbot Embedded Page"
                            className="chat-url-iframe"
                            allowFullScreen
                        />
                    )}
                    {/* Close Button */}
                    <button className="close-btn" onClick={handleCloseUrlPopup}>
                        ❌
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ChatPopup;
